import React, { useContext } from "react";
import logo from "../assets/logo-white.png"
import { ThemeContext } from '../themeContext';
import './Navbar.css';


export default function Footer({ verified }) {
    const { verifiedGlobal, updateVerifiedGlobal, registrationSuccessGlobal } = useContext(ThemeContext);
    return (
        <footer className="navbar-i" style={!verifiedGlobal || registrationSuccessGlobal === true ? {
            position: "relative",
            left: 0,
            bottom: 0,
            right: 0,
            paddingBlock: "30px"
        } : undefined}>
            <nav className="navbar-i-menu">
                <a href="#home" className="navbar-i-item">Home</a>
                <a href="#about" className="navbar-i-item">About</a>
                <a href="#contact" className="navbar-i-item">Contact</a>
                <a href="#register" className="navbar-i-item">Download</a>
            </nav>

            <div className="navbar-i-logo">
                <div className="footer-logo">
                    <img src={logo}  alt="Merchant-logo" width="150px"/>
                </div>
                <div className="logo-subtext">Shubox, 2024</div>
            </div>
        </footer>
    )
}

